type TBusinessHours = {
  [key: string]: {
    open: string;
    close: string;
    closed: boolean;
  };
};

export const MOBILE_BUSINESS_HOURS: TBusinessHours = {
  monday: { open: "09:00", close: "16:00", closed: true },
  tuesday: { open: "09:00", close: "16:00", closed: false },
  wednesday: { open: "09:00", close: "16:00", closed: true },
  thursday: { open: "09:00", close: "16:00", closed: false },
  friday: { open: "09:00", close: "16:00", closed: true },
  saturday: { open: "09:00", close: "17:00", closed: true },
  sunday: { open: "09:00", close: "17:00", closed: true },
};

export const SALON_BUSINESS_HOURS: TBusinessHours = {
  monday: { open: "10:00", close: "20:00", closed: true },
  tuesday: { open: "10:00", close: "18:00", closed: false },
  wednesday: { open: "10:00", close: "20:00", closed: false },
  thursday: { open: "10:00", close: "20:00", closed: false },
  friday: { open: "10:00", close: "20:00", closed: false },
  saturday: { open: "09:00", close: "16:00", closed: false },
  sunday: { open: "09:00", close: "16:00", closed: true },
};

export const orderedDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
